import { onBeforeUnmount, onMounted } from 'vue'

import { useAccountEventsStore } from '@/stores/account-events'

/**
 * Run `onEnded` when a temporary swap on the account is reverted or runs out,
 * so a screen showing swaps can update without a reload (ZEN-2030). Listens on
 * the shared account connection from mount until unmount.
 *
 * Events are not replayed, so `onEnded` also runs, with `null`, when the
 * connection comes back from a drop: a swap may have ended while it was down.
 *
 * @param {(event: object|null) => void} onEnded - Receives the broadcast
 *   payload (projectKey, environmentKey, sourceEnvironmentKey, overlayUlid and
 *   action), or null after a reconnect. The screen decides whether the swap is
 *   one it shows.
 * @returns {void}
 */
export function useSwapEndedEvents(onEnded) {
    const accountEvents = useAccountEventsStore()
    let unsubscribers = []

    onMounted(() => {
        unsubscribers = [
            accountEvents.on('flag-swap-ended', (event) => onEnded(event)),
            accountEvents.onResync(() => onEnded(null)),
        ]
    })

    onBeforeUnmount(() => {
        unsubscribers.forEach((unsubscribe) => unsubscribe())
        unsubscribers = []
    })
}
